export default "__VITE_ASSET__Dec2uDtj__"